import * as React from "react";
import { useRef } from "react";
import { PracticeDetails } from "./Practice";
import TitledPanel from "../commons/components/TitledPanel";
import LabelledDataForm from "../label/LabelledDataForm";
import EditAction from "../commons/components/action/EditAction";

export default function PracticeDetailsView({
  practiceDetails,
  editPracticeUrl,
  isAdmin,
}: {
  practiceDetails: PracticeDetails;
  editPracticeUrl: string;
  isAdmin: boolean;
}) {
  const editActionRef = useRef<HTMLAnchorElement>(null);

  const editAction = (
    <a href={editPracticeUrl} ref={editActionRef}>
      <EditAction />
    </a>
  );

  return (
    <TitledPanel
      title={i18n["Page.PracticeManagement.PracticeDetails"]}
      withShadow={true}
      action={isAdmin ? editAction : undefined}
    >
      <LabelledDataForm
        data={[
          {
            label: i18n["Page.PracticeManagement.Practice.Name"],
            value: practiceDetails.name,
          },
          {
            label: i18n["Page.PracticeManagement.Practice.PhoneNumber"],
            value: practiceDetails.phoneNumber,
          },
          {
            label: i18n["Page.PracticeManagement.Practice.Address"],
            value: practiceDetails.address.displayAddress,
          },
        ]}
      />
    </TitledPanel>
  );
}
